/**
 * This file was automatically generated by `bwcx-client-vue`.
 * DO NOT MODIFY IT BY HAND.
 */

import { parseRoutes, RenderMethodKind } from 'bwcx-client-vue3';

const clientRoutes = parseRoutes([
  {
    name: 'Home',
    path: '/',
    fullPath: '/',
    component: () => import(/* webpackChunkName: "Home" */ '../modules/home/home.view.vue'),
    routeProps: undefined,
    priority: undefined,
    renderMethod: RenderMethodKind.SSR,
    otherOptions: undefined,
  },
  {
    name: 'Releases',
    path: '/releases',
    fullPath: '/releases',
    component: () => import(/* webpackChunkName: "Releases" */ '../modules/releases/releases.view.vue'),
    routeProps: undefined,
    priority: undefined,
    renderMethod: RenderMethodKind.SSR,
    otherOptions: undefined,
  },
]);

export default clientRoutes;

